import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 second timeout
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Contact Service
export const contactService = {
  // Submit contact form
  async submitForm(formData) {
    try {
      const response = await api.post('/contact', formData);
      return {
        success: true,
        data: response.data,
        message: 'Thank you! We will contact you soon.'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.detail || 'Failed to submit form. Please try again.'
      };
    }
  },

  // Get all inquiries (for admin)
  async getInquiries() {
    try {
      const response = await api.get('/contact');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to fetch inquiries'
      };
    }
  },

  // Update inquiry status
  async updateStatus(inquiryId, status) {
    try {
      const response = await api.patch(`/contact/${inquiryId}`, { status });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to update status'
      };
    }
  }
};

// Calendly Service
export const calendlyService = {
  // Get available appointment slots
  async getAvailability() {
    try {
      const response = await api.get('/calendly/availability');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to fetch availability'
      };
    }
  },

  // Book appointment
  async bookAppointment(bookingData) {
    try {
      const response = await api.post('/calendly/book', bookingData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to book appointment'
      };
    }
  }
};

// WhatsApp Service
export const whatsappService = {
  // Send WhatsApp message
  async sendMessage(messageData) {
    try {
      const response = await api.post('/whatsapp/send', messageData);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to send WhatsApp message'
      };
    }
  },

  // Get WhatsApp redirect URL
  async getWhatsAppUrl() {
    try {
      const response = await api.get('/whatsapp/redirect');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to get WhatsApp URL'
      };
    }
  }
};

// Blog Service
export const blogService = {
  // Get all blog posts
  async getPosts() {
    try {
      const response = await api.get('/blog');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to fetch blog posts'
      };
    }
  },

  // Get single blog post
  async getPost(postId) {
    try {
      const response = await api.get(`/blog/${postId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: 'Failed to fetch blog post'
      };
    }
  }
};

// Health check
export const healthCheck = async () => {
  try {
    const response = await api.get('/health');
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    return {
      success: false,
      message: 'Backend service unavailable'
    };
  }
};

export default api;